export default __webpack_public_path__ + "static/media/itauPY_flag.0c1b1c4c.svg";